import {
  Alert,
  Modal,
  ModalContent,
  Typography
} from "@dealer-center/core-components";
import type { DeleteDepartmentModal } from "../Departments";
import { useDeleteDepartment } from "@dealer-center/ddc-pages-departments-fetch";
import type { AccountEntity } from "@dealer-center/ddc-api-account-interface";
import { useOutletContext } from "react-router-dom";
import { useState } from "react";

interface DeleteDepartmentProps extends DeleteDepartmentModal {
  hideModal: () => void;
}
export const DeleteDepartment = ({
  hideModal,
  modalToShow,
  selected
}: DeleteDepartmentProps) => {
  const mutation = useDeleteDepartment();
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const { accountEntity } = useOutletContext<{
    accountEntity: AccountEntity;
  }>();

  const handleDelete = () => {
    setErrorMsg(null); // Clear previous errors
    mutation
      .mutateAsync({
        accountId: accountEntity.id,
        department: selected.type
      })
      .then(() => hideModal())
      .catch(error => {
        console.error("Failed to delete department:", error);
        setErrorMsg(
          error.message || "Failed to delete department. Please try again."
        );
      });
  };

  return (
    <Modal
      footer={{
        primary: {
          label: "Delete",
          disabled: mutation.isPending,
          action: handleDelete,
          isLoading: mutation.isPending
        },
        options: {
          label: "Cancel",
          action: () => hideModal(),
          disabled: mutation.isPending
        }
      }}
      header="Delete Department"
      show={modalToShow === "delete"}
      size="large"
      onHide={() => !mutation.isPending && hideModal()}
    >
      <ModalContent>
        {errorMsg && (
          <Alert sx={{ mb: 2 }} type="error">
            {errorMsg}
          </Alert>
        )}
        <Typography variant="list-md">Name: {selected.label}</Typography>
        <Typography variant="list-md">Type: {selected.type}</Typography>
        <Typography sx={{ color: "text.secondary", mt: 2 }} variant="body-sm">
          This action cannot be undone and will remove all associated department
          data.
        </Typography>
      </ModalContent>
    </Modal>
  );
};
